const validateMazorKitCodeOnCTAbtnClickUtil = ({
    procedureInfoData,
    validateMazorCodeRes,
    dispatch,
    validateMazorCodeRequest,
    clickedBtn,
}) => {
    const additionalProcedureData = procedureInfoData.additionalProcedure;
    const mazorxIdx =
        additionalProcedureData &&
        additionalProcedureData.findIndex(
            (x) => x.description === 'MazorX Robot Used'
        );

    if (
        mazorxIdx >= 0 &&
        additionalProcedureData[mazorxIdx] &&
        additionalProcedureData[mazorxIdx].isSelected &&
        additionalProcedureData[mazorxIdx].mazorKitCode &&
        validateMazorCodeRes?.statusCode === 'draft'
    ) {
        dispatch(
            validateMazorCodeRequest(
                {
                    mazorKitCode: encodeURIComponent(additionalProcedureData[mazorxIdx].mazorKitCode),
                },
                clickedBtn
            )
        );
    }
};

export default validateMazorKitCodeOnCTAbtnClickUtil;